"use strict";
exports.__esModule = true;
exports.setInPath = void 0;
var isEmpty_1 = require("./isEmpty");
var setInPath = function (params) {
    var obj = params.obj, path = params.path, value = params.value, excludeEmpty = params.excludeEmpty;
    if (excludeEmpty && (0, isEmpty_1.isEmpty)(value)) {
        return obj;
    }
    var objCurrent = obj;
    path.forEach(function (pathPart, i) {
        if (i === path.length - 1) {
            objCurrent[pathPart] = value;
        }
        else {
            if (!Object.prototype.hasOwnProperty.call(objCurrent, pathPart)) {
                objCurrent[pathPart] = {};
            }
            objCurrent = objCurrent[pathPart];
        }
    });
    return obj;
};
exports.setInPath = setInPath;
//# sourceMappingURL=setInPath.js.map